import * as React from 'react'

interface StationListProps {
  style: React.CSSProperties
  className: string
}

const StationList: React.SFC<StationListProps> = ({ children, className, style }) => {
  return (
    <div className={className} style={{ minHeight: '100px', width: '100%', ...style }}>
      {children}
    </div>
  )
}

export default StationList



// WEBPACK FOOTER //
// ./src/components/station/StationList.tsx